import { defaultsMixin } from '../defaults';

export const childMixin = {
  inject: ['sharedState'],
  mixins: [defaultsMixin],
  computed: {
    masks() {
      return this.sharedState.masks;
    },
    theme() {
      return this.sharedState.theme;
    },
    locale() {
      return this.sharedState.locale;
    },
    dayPopoverId() {
      return this.sharedState.dayPopoverId;
    },
  },
  methods: {
    format(date, mask) {
      return this.locale.format(date, mask);
    },
    pageForDate(date) {
      return this.locale.getDateParts(this.locale.normalizeDate(date));
    },
  },
};



// WEBPACK FOOTER //
// ./~/v-calendar/src/utils/mixins/child.js